import React, { useState, useEffect } from "react";
import QRCode from "qrcode.react";
import "./QRScanner.modules.css";
import { useTranslation } from "react-i18next";
import { Redirect } from "react-router-dom";
import * as AppUrls from "../../../constants/AppUrls";
import NavbarOnboarding from "../NavbarOnboarding/NavbarOnboarding";
import KYCimg from "../../../assets/images/Sharjah/KYC.png";
import { CloudArrowUp } from "react-bootstrap-icons";
import * as Helpers from "../../../global/Helpers";
import i18next from "i18next";
import axios from "axios";
import * as Constants from "../../../constants/Constants";
import { connect } from "react-redux";
import { groupIdSignal } from "../OnboardingHome/OnboardingHome";
import * as utils from "../../../global/utils";
import SessionExpiredPOPup from "../SessionExpiredPOPup/SessionExpiredPOPup";

import { confirmAlert } from "react-confirm-alert";
const QRScanner = (props) => {
  const { t } = useTranslation();

  const [redirect, setRedirect] = useState(null);
  const [text, setText] = useState("");
  const [isVerify, setisVerify] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);
  const [ExistingSIB, setExistingSIB] = useState(false);
  const [NonSIB, setNonSIB] = useState(false);
  const [OpenAccountSIB, setOpenAccountSIB] = useState(false);
  const [isInternational, setIsInternational] = useState(false);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [EIDData, setEIDData] = useState(null);
  const [passportImage, setPassportImage] = useState(null);

  var MSG = "";
  var MSG_PassportText = "";
  
  if (groupIdSignal) {
    if (groupIdSignal.value === "Personal") {
      MSG = t("uploadEID")
      MSG_PassportText = t("VerifyPassportText")
    } else if (groupIdSignal.value === "Minor") {
      MSG = t("uploadEIDGuardian")
      MSG_PassportText = t("PassportTextGuardian")
    }
  }
  const handleChange = (e) => {
    setText(e.target.value);
  };

  useEffect(() => {
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [timeoutId]);

  const handleBack = (e) => {
    e.preventDefault();
    setRedirect(AppUrls.onboardingLogin);
  };
  const onclickVerifymyEID = (e) => {
    setisVerify(true);
    // setExistingSIB(true);
    //setRedirect(AppUrls.onboardingUserConfirms);
    // const id = setTimeout(() => {
    //   setRedirect(AppUrls.onboardingUserConfirms)
    // }, 1000);
    // setTimeoutId(id);
  };

  const onclickInternational = (e) => {
    //setisVerify(true);
    setIsInternational(true);
    //setExistingSIB(false);
    //setOpenAccountSIB(false);
    // setNonSIB(false);
    setRedirect(AppUrls.onboardingUserConfirms);
  };
  const onclickExistingSIB = (e) => {
    setisVerify(true);
    setExistingSIB(true);
    setOpenAccountSIB(false);
    setNonSIB(false);
    setIsInternational(false);
    setRedirect(AppUrls.onboardingUserConfirms);
  };
  const onclickNonSIB = (e) => {
    setisVerify(true);
    setExistingSIB(false);
    setOpenAccountSIB(false);
    setNonSIB(true);
    setIsInternational(true);

    setRedirect(AppUrls.onboardingUserConfirms);
  };
  const onclickOpenAccountSIB = (e) => {
    setisVerify(true);
    setExistingSIB(false);
    setNonSIB(false);
    setOpenAccountSIB(true);
    setIsInternational(false);
    setRedirect(AppUrls.onboardingUserConfirms);
  };

  // const handleDrop2 = (event) => {
  //   ;
  //   event.preventDefault();

  //   const file = event.dataTransfer.files[0];
  //   if (file && file.type === "application/pdf") {
  //     setFile(event.target.files[0]);
  //     const imageUrl = URL.createObjectURL(file);
  //     setPassportImage(imageUrl);
  //     if (file) setFileName(file.name);
  //   } else {
  //     Helpers.errorNotify(t("selectPDF"), i18next.language);
  //     setFile(null);
  //     setFileName("");
  //   }
  // };
  const handleDrop = (event) => {
    event.preventDefault(); // Prevent default behavior (e.g., opening the file in the browser)

    const file = event.dataTransfer.files[0]; // Get the file from dataTransfer
    if (file && file.type === "application/pdf") {
      setFile(file); // Set the file state
      const imageUrl = URL.createObjectURL(file); // Create an object URL for the file
      setPassportImage(imageUrl); // Set the image URL
      setFileName(file.name); // Set the file name
    } else {
      Helpers.errorNotify(t("selectPDF"), i18next.language);
      setFile(null);
      setFileName("");
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file && file.type === "application/pdf") {
      setFile(event.target.files[0]);
      const imageUrl = URL.createObjectURL(file);
      setPassportImage(imageUrl);
      if (file) setFileName(file.name);
    } else {
      Helpers.errorNotify(t("selectPDF"), i18next.language);
      setFile(null);
      setFileName("");
    }
  };

  // const handleFileChange = (e) => {
  //   setFile(e.target.files[0]);
  // };

  const validateSubmit = () => {
    ;
    if (!file) {
      Helpers.errorNotify(
        t("PleaseUpdateYourExpiredDocuments"),
        i18next.language
      );
      return false;
    }
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateSubmit()) return;
    
    CallInsertAttachments();
    handleUploadAndRequest();
  };


  const CallInsertAttachments = async () => {
    ;

    var arrayofbyte = await Helpers.getAsByteArray(file);
    var bytesString = [].slice.call(arrayofbyte);

    var FileType = file.type;
    FileType = FileType.split("/");
    if (FileType !== null) {
      FileType = FileType[1];
      FileType = FileType.toUpperCase();
    }
    var field_id = "";
    if (groupIdSignal) {
      if (groupIdSignal.value === "Personal" && isVerify) {
        
        field_id = "98";
      } else if (groupIdSignal.value === "Minor" && isInternational) {
        
        field_id = "105";
      } else  if (groupIdSignal.value === "Minor" && isVerify) {
        
        field_id = "168";
      } else if (groupIdSignal.value === "Personal" && isInternational) {
        
        field_id = "99";
      }
    }
    const body = {
      fields: [{ DocType: FileType, field_id: "99", field_value: bytesString }],
      RequestId: localStorage.getItem("RID"),
    };

    var response = utils.CallInsertAttachments(
      Constants.InsertAttachments,
      body
    );
    await response
      .then((response) => {
        ;
          if (response.data.ErrorMsg === "success") {
              console.log("FileUplodedSuccessfully");
        //   Helpers.successNotify(t("FileUplodedSuccessfully"));
          //setRedirect(RedirectPath);
        } else if (response.data.ErrorMsg === "Invalid token") {
          confirmAlert({
            customUI: ({ onClose }) => {
              return (
                <SessionExpiredPOPup
                  setRedirect={setRedirect}
                  onClose={onClose}
                />
              );
            },
          });
        } else {
          Helpers.errorNotify(response.data.ErrorMsg, i18next.language);
        }
      })
      .catch((error) => {
        console.log("CallInsertAttachments", error);
      });
  };

  // Convert file to Base64
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(",")[1]); // Extract Base64 part
      reader.onerror = (error) => reject(error);
    });
  };

  // Handle API call
  const handleUploadAndRequest = async () => {
    try {
      // Convert PDF to Base64
      const base64String = await convertToBase64(file);

      // Prepare payload
      const payload = {
        processParam: {
          scenario: "FullAuth",
          authParams: {
            checkLiveness: false,
          },
        },
        List: [
          {
            ImageData: {
              image: base64String,
            },
          },
        ],
      };
      ;

      // Send API request
      const apiResponse = await axios.post(
        localStorage.getItem(Constants.localStorageConstants.RegulaUrl),
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const mrzData = apiResponse.data.ContainerList?.List?.find(
        (item) => item.result_type === 3
      )?.DocVisualExtendedInfo?.pArrayFields;

      const IDENTITY_CARD_NUMBER_Field = mrzData?.find(
        (field) => field.FieldType === 142
      );
      const nameField = mrzData?.find((field) => field.FieldType === 25);
      const DateofbirthField = mrzData?.find((field) => field.FieldType === 5);
      const NATIONALITY_CODE = mrzData?.find((field) => field.FieldType === 26);
      const expiryField = mrzData?.find((field) => field.FieldType === 3);
      const GenderField = mrzData?.find((field) => field.FieldType === 12);

      // const docNumberField = mrzData?.find((field) => field.FieldType === 2);

      setEIDData({
        name: nameField?.Buf_Text || "",
        birthDate: DateofbirthField
          ? formatDate(DateofbirthField.Buf_Text)
          : "",
        nationality: NATIONALITY_CODE?.Buf_Text || "",
        expiryDate: expiryField ? formatDate(expiryField.Buf_Text) : "",
        Gender: GenderField?.Buf_Text || "",
        EMIRATES_ID: IDENTITY_CARD_NUMBER_Field?.Buf_Text || "",
      });
      if (!EIDData) setRedirect(AppUrls.CustomerInfo);
    } catch (err) {
      // setError(err.message || "Something went wrong");
    } finally {
      // setLoading(false);
    }
  };

  const formatDate = (data) => {
    ;
    const year = data.substring(0, 2);
    const month = data.substring(2, 4);
    const day = data.substring(4, 6);

    // Step 2: Dynamically handle year (if year is less than 30, assume it's 2000s, else 1900s)
    const fullYear = parseInt(year) < 30 ? `20${year}` : `19${year}`;

    // Step 3: Create the Date manually by using `setFullYear`, `setMonth`, `setDate`
    const date = new Date(); // Start with an empty date object

    // Set year, month, and day manually
    date.setFullYear(fullYear);
    date.setMonth(parseInt(month) - 1); // Months are 0-indexed, so subtract 1
    date.setDate(parseInt(day));
    const customFormattedDate = `${date.getDate()}-${
      date.getMonth() + 1
    }-${date.getFullYear()}`;

    //const customFormattedDate = `${year}-${month}-${day}`;
    return customFormattedDate;
  };
  var EnableOnboardingInternational = false;
  var DeviceConfigs = JSON.parse(localStorage.getItem("DeviceConfigs"));
   
      if (DeviceConfigs !== null && DeviceConfigs !== undefined ) {
        EnableOnboardingInternational = DeviceConfigs.EnableOnboardingInternational.toUpperCase() == "TRUE" ? true : false;
      }

  if (redirect !== null) {
    return (
      <Redirect
        to={{
          pathname: redirect,
          state: { isInternational: isInternational, EIDData: EIDData },
        }}
      />
    );
    // return <Redirect to={redirect} />;
  }

  
  return (
    <>
      <NavbarOnboarding />
      <div className="login-main-container">
        <div className="KYCDivImg">
          <h2 className="OpenYourAccountwithUs">{t("OpenYourAccountwithUs")}</h2>
          <img className="KYCImg" src={KYCimg} />
        </div>
        <div className="QRCode-container">
          <div className="QRCode-form">
            <div className="qr-code-generator-container">
              {isInternational ? (
                <h2 style={{ marginBottom: "8%" }}>
                  {MSG_PassportText}
                </h2>
              ) : isVerify ? (
                <h2 style={{ marginBottom: "8%" }}>{MSG}</h2>
              ) : (
                <h2 style={{ marginBottom: "8%" }}>{t("VerifyEIDText")}</h2>
              )}

              {isVerify ? (
                <>
                  {/* <h3>QR Code Generator</h3>
                  <input
                    type="text"
                    placeholder="Enter text here..."
                    value={text}
                    onChange={handleChange}
                  /> */}
                  <div className="qr-code-display ">
                    {/* {<QRCode value="https://www.google.com/" renderAs="canvas" />} */}

                    {/* <div className="form-group-uploadON">
                      <label htmlFor="file-upload">{t("Select front & back side of the EID File")}</label>
                      <input id="file-upload" type="file" onChange={handleFileChange} />
                    </div> */}

                    <div className="upload-container-new">
                      <label for="file-input" class="browse-link">
                        <div
                          className="drag-drop-area  mb-4"
                          onDragOver={(e) => e.preventDefault()}
                          onDrop={handleDrop}
                        >
                          <CloudArrowUp size={30} color="gray" />
                          <p>
                            {i18next.language === "ar"
                              ? "اسحب وأفلِت الملف هنا"
                              : "Drag & drop file here"}
                            <span>
                              {i18next.language === "ar" ? "أو" : "or"}
                            </span>
                            <label for="file-input" class="browse-link">
                              {t("browseFile")}
                            </label>{" "}
                            {i18next.language === "ar"
                              ? "من الجهاز"
                              : "from device"}
                          </p>
                          <input
                            id="file-input"
                            type="file"
                            accept="application/pdf"
                            onChange={handleFileChange}
                            hidden
                          />
                        </div>
                      </label>
                      {/* Image Upload Section */}
                      {passportImage ? (
                        <div className="upload-section">
                          <label
                            htmlFor="passport-upload"
                            className="upload-label"
                            style={{ height: "400px" }}
                          >
                            {/* <iframe src={passportImage} title="PDF Preview" width="100%" height="100%" /> */}
                            <iframe
                              src={`${passportImage}#toolbar=0`}
                              title="PDF Preview"
                              width="100%"
                              height="100%"
                              style={{ border: "none" }}
                            />
                          </label>
                        </div>
                      ) : null}
                      {fileName && (
                        <p className="file-name">
                          {i18next.language === "ar"
                            ? "الملف المحدد:"
                            : "Selected File:"}{" "}
                          {fileName}
                        </p>
                      )}
                      <button
                        className="submit-button "
                        onClick={(e) => handleSubmit(e)}
                      >
                        {t("Next")}
                      </button>
                    </div>
                  </div>
                </>
              ) : null}
              {!isVerify ? (
                <button
                  className="submit-button mb-2"
                  onClick={(e) => onclickVerifymyEID(e)}
                >
                  {t("VerifymyEID")}
                </button>
              ) : null}
              {/* for testing
              {isVerify ? (
                <>
                 
                  <button className="submit-button mb-2" onClick={(e) => onclickExistingSIB(e)}>
                    {t("ExistingSIB")}
                  </button>
                  <button className="submit-button mb-2" onClick={(e) => onclickNonSIB(e)}>
                    {t("NonSIB")}
                  </button>
                  <button className="submit-button mb-2" onClick={(e) => onclickOpenAccountSIB(e)}>
                    {t("OpenAccountSIB")}
                  </button>
                </>
              ) : null} */}
              
              {!isVerify  && EnableOnboardingInternational
               ? (
                <button
                  className="submit-button"
                  onClick={(e) => onclickInternational(e)}
                >
                  {t("InternationalAccount")}
                </button>
              ) : null}

              <div>
                {/* <button
                  className={"link"}
                  style={{
                    width: "100%",
                    textDecoration: "underline",
                    marginTop: "1rem",
                    marginLeft: "auto",
                    marginRight: "auto",
                    background: "transparent",
                    border: "none",
                    color: "#0b1d81",
                    cursor: "pointer",
                  }}
                  onClick={handleBack}>
                  {t("back")}
                </button> */}
                {/* <button className="backBtn" onClick={handleBack}>
                  {t("back")}
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    permData: state.permData,
  };
};
export default connect(mapStateToProps, null)(QRScanner);
